<template>
  <div class="rt-header-button-group">
    <slot />
    <div v-if="showMore" class="button-group-more">
      <el-popover
        ref="popover"
        trigger="hover"
        popper-class="rtElPopover"
        @show="moveBtns"
      >
        <div slot="reference" class="rt-button-more">...</div>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtHeaderButtonGroup',
  props: {
    maxBtns: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      showMore: false,
      btns: [],
      movedBtns: [],
      moved: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.$slots.default) {
        this.btns = this.$slots.default.filter(item => {
          return item.tag;
        });
      }
      if (this.btns.length >= this.maxBtns) {
        this.showMore = true;
        this.removeBtns();
      }
    },
    removeBtns() {
      let movedBtns = [];
      this.btns.forEach((item, index) => {
        if (index >= this.maxBtns - 1) {
          movedBtns.push(item.elm);
          this.$el.removeChild(item.elm);
        }
      });
      this.movedBtns = movedBtns.slice();
    },
    moveBtns() {
      if (this.moved) return;
      let divWrapper = document.createElement('div');
      divWrapper.classList.add('rt-button-group-popper-wrapper');
      this.movedBtns.forEach(item => {
        divWrapper.appendChild(item);
      });
      this.$refs.popover.$refs.popper.appendChild(divWrapper);
      this.moved = true;
    }
  }
};
</script>

<style lang="less">
.rt-button-group-popper-wrapper {
  .el-button {
    padding: 7px 12px;
    border-color: #ced5ef;
  }
}

.el-button--primary {
  border-color: #409eff !important;
}

.rt-header-button-group {
  // height: 50px;
  display: flex;
  align-items: center;

  .el-button {
    padding: 7px 15px;
    border-color: #ced5ef;
    border-radius: 0;
  }

  .el-button + .el-button {
    margin-left: 0;
    border-left: 0;
  }

  .button-group-more {
    // margin-left: 10px;

    .el-popover__reference {
      box-sizing: border-box;
      height: 30px;
      line-height: 20px;
      padding: 0 18px;
      border: 1px solid #ced5ef;
      border-left: 0;
      color: #6388c2;
    }
  }
}

.rtElPopover {
  // left: 1220px !important;
  min-width: 80px;

  .rt-button-group-popper-wrapper {
    .el-button {
      display: block;
      margin: 0 auto;
    }

    .el-button + .el-button {
      margin-top: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtHeaderButtonGroup.vue?2604549a